module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "ushk-rili_list-wrap J_rili_listItem"
  }, [(!_vm.datas || !_vm.datas.length) ? _c('li', {
    staticClass: "ushk-rili_list-empty"
  }, [_c('img', {
    attrs: {
      "src": "//cdn.jin10.com/assets/img/sites/rili/empty_event.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(!_vm.datas ? '加载中......' : '今日无财经大事'))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.datas), function(data, index) {
    return _c('li', {
      staticClass: "ushk-rili_list-item"
    }, [_c('div', {
      staticClass: "ushk-rili_list-country"
    }, [_c('img', {
      attrs: {
        "src": ("//cdn.jin10.com/assets/img/commons/flag/flash/" + (data.country) + ".png")
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "ushk-rili_list-body"
    }, [_c('div', {
      staticClass: "ushk-rili_list-h"
    }, [_c('div', {
      staticClass: "ushk-rili_list-time"
    }, [_c('i', {
      staticClass: "ushk-icon ushk-icon_time"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(data.public_time))])]), _vm._v(" "), _c('star', {
      attrs: {
        "width": data.star
      }
    })], 1), _vm._v(" "), _c('h3', {
      staticClass: "ushk-rili_list-title"
    }, [_vm._v(_vm._s(data.eventcontent))])]), _vm._v(" "), _c('div', {
      staticClass: "ushk-rili_list-tag"
    }, [_c('p', {
      staticClass: "ushk-btn ushk-btn_plain-primary"
    }, [_c('i', {
      staticClass: "ushk-icon ushk-icon_time"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(data.public_time))])])])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60af1662","hasScoped":false,"transformToRequire":{"img":["src","srcset"]}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/calendar/modules/MobileContent/EventsList.vue
// module id = fhCV
// module chunks = 3